import { render, staticRenderFns } from "./ShopNotFoundView.vue?vue&type=template&id=3b621df8&"
import script from "./ShopNotFoundView.vue?vue&type=script&lang=ts&"
export * from "./ShopNotFoundView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b621df8')) {
      api.createRecord('3b621df8', component.options)
    } else {
      api.reload('3b621df8', component.options)
    }
    module.hot.accept("./ShopNotFoundView.vue?vue&type=template&id=3b621df8&", function () {
      api.rerender('3b621df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopNotFoundView.vue"
export default component.exports